import React, { useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Hamburger.css'
import L from '../assets/Logo.svg'
import C from '../assets/Close.svg'


import gsap from "gsap";
import { useGSAP } from "@gsap/react";

import { useTranslation } from 'react-i18next';

const Hamburger = ({ isOpen, closeMenu }) => {
  
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
    const menuRef = useRef();

  useGSAP(() => {
    if (isOpen) {
      gsap.to(menuRef.current, { x: 0, opacity: 1, duration: 0.5, ease: 'power3.out', zIndex: 5, display: 'flex' });
    } else {
      gsap.to(menuRef.current, { x: -100, opacity: 0, duration: 0.5, ease: 'power3.in', zIndex: 0, display: 'none' });
    }
  }, [isOpen]);
  return (
    <div ref={menuRef} className="Hamburger">
        <div className="Hamburger-topbar">
            <img alt="Khamsa Insurance and Reinsurance Brokers" src={L} className="Hamburger-topbar-logo"/>
            <div onClick={closeMenu} className="Hamburger-topbar-close">
                <img alt=""  src={C} className="Hamburger-topbar-close-icon"/>
            </div>
        </div>
        <div className="Hamburger-content">
           <Link to='/who-we-are' onClick={closeMenu}><div className="Hamburger-content-button">{t('TopBar1')}</div></Link>
           <Link to='/what-we-offer' onClick={closeMenu}> <div className="Hamburger-content-button">{t('TopBar2')}</div></Link>
            <Link to='/news' onClick={closeMenu}><div className="Hamburger-content-button">{t('TopBar3')}</div></Link>
            <Link to='/contact' onClick={closeMenu}> <div className="Hamburger-content-button">{t('TopBar4')}</div></Link>
            <div className="Hamburger-content-line"/>
            <div className="Hamburger-content-lang">
                <p className="Hamburger-content-lang-text" onClick={() => i18n.changeLanguage('az')}>AZ</p>
                <div className="Hamburger-content-lang-line"/>
                <p className="Hamburger-content-lang-text2" onClick={() => i18n.changeLanguage('en')}>EN</p>
            </div>
        </div>
    </div>
  )
}

export default Hamburger